import { Moon, Sun } from 'lucide-react';
import { Button } from '@/components/ui/button';

interface ThemeToggleProps {
  isDark: boolean;
  onToggle: () => void;
}

export function ThemeToggle({ isDark, onToggle }: ThemeToggleProps) {
  return (
    <div className="fixed bottom-5 right-5 z-[70]">
      <Button
        type="button"
        variant="outline"
        size="icon"
        onClick={onToggle}
        className="h-11 w-11 rounded-full border border-border bg-card-background/90 shadow-lg backdrop-blur transition-all hover:-translate-y-0.5"
        aria-label={isDark ? 'Switch to light mode' : 'Switch to dark mode'}
        title={isDark ? 'Switch to light mode' : 'Switch to dark mode'}
      >
        {isDark ? <Sun className="h-5 w-5 text-warning" /> : <Moon className="h-5 w-5 text-primary-hover" />}
      </Button>
    </div>
  );
}
